import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { fetchOverview } from "../../store/backlinks/operations";
import { isFetchingOverview, getOverview, getOverviewSettings } from "../../store/backlinks/selectors";
import { getSelectedWebsiteDomain } from "../../store/tracked_websites/selectors";
import Overview from "../../components/Backlinks/BacklinksOverview";
import { BACKLINKS_OVERVIEWS_CHART_INTERVAL_LENGTH_IN_WEEKS } from "../../settings/config";

const endDate = moment().utc();
const endDateStr = endDate.format("YYYY-MM-DDTHH:mm:ss");
const startDate = endDate.subtract(BACKLINKS_OVERVIEWS_CHART_INTERVAL_LENGTH_IN_WEEKS, "weeks");
const startDateStr = startDate.format("YYYY-MM-DDTHH:mm:ss");

class BacklinksOverview extends Component {
  componentDidMount = (_) => {
    this.props.fetchOverview(this.props.domain, startDateStr, endDateStr);
  };
  render() {
    return (
      <Overview
        isLoading={this.props.isLoading}
        overview={this.props.overview}
        settings={this.props.settings}
        showChart={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let domain = ownProps.domain || getSelectedWebsiteDomain(state);
  return {
    domain: domain,
    isLoading: isFetchingOverview(state, domain),
    overview: getOverview(state, domain, startDateStr, endDateStr),
    settings: getOverviewSettings(state)
  };
};

export default connect(mapStateToProps, { fetchOverview })(BacklinksOverview);
